var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tariffStructure)?_c('v-card-text',{staticClass:"py-0"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"2"}},[_c('span')])],1)],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }